import { Link } from "react-router-dom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { BarChart3 } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { ChartTooltip } from "@/shared/ui/ChartTooltip";
import { brand } from "@/shared/lib/safecheckBrand";
import { adminMonthlyVolume } from "../../data/adminDashboard";

export function MonthlyVolumeChart() {
  const { t } = useTranslation();
  const { tick, grid } = useChartTheme();

  const data = adminMonthlyVolume.map((item) => ({
    ...item,
    label: `${t.common.months[item.month] ?? item.month} 2026`,
  }));

  return (
    <Link
      to="/dashboard/statistics"
      className="theme-card block p-5 transition-all hover:border-accent/40 hover:shadow-[var(--shadow)]"
    >
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground">
          {t.safecheck.adminDashboard.monthlyVolume.title}
        </h3>
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal-soft">
          <BarChart3 size={16} className="text-teal" />
        </div>
      </div>

      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data} margin={{ top: 12, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={grid} vertical={false} />
          <XAxis
            dataKey="label"
            axisLine={false}
            tickLine={false}
            tick={{ fill: tick, fontSize: 11 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: tick, fontSize: 11 }}
            domain={[0, 21]}
            ticks={[0, 3, 6, 9, 12, 15, 18, 21]}
          />
          <Tooltip content={<ChartTooltip />} />
          <Bar dataKey="value" fill={brand.lime} radius={[6, 6, 0, 0]} maxBarSize={48} />
        </BarChart>
      </ResponsiveContainer>
    </Link>
  );
}
